import React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import head from "./head.biz";

function EnhancedTableHead({ showTab, displayLeadNumberColumn }: { showTab: string, displayLeadNumberColumn?: boolean }) {
  const headArray = head(showTab, displayLeadNumberColumn);

  return (
    <TableHead style={{ backgroundColor: "#4b4b4b" }}>
      <TableRow>
        <TableCell></TableCell>
        {headArray?.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{ color: "white" }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default EnhancedTableHead;
